import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    MultilineColumn,
    DateTimeColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);
  return [
    {
      Header: '',
      columns: [
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'despatchId')
          .withWidth(210)),
        new DateTimeColumn('Despatch closed', 'despatchCloseDate')
          .withWidth(150),
      ],
    },
    {
      Header: 'Interchanges',
      columns: [
        new TextColumn('PREDES', 'interchangeFileName.predes'),
        new MultilineColumn('RESDES', 'interchangeFileName.resdes'),
      ],
    },
  ];
};
